import { isResponseError } from '@luna/api';

import type { ProblemError } from './ViolationsService';

export type ResponseWithErrors = { responseJSON: { errors: ProblemError[] } };

function hasErrors(value: unknown): value is { errors: ProblemError[] } {
    return value instanceof Object && 'errors' in value;
}

export function isResponseWithErrors(error: unknown): error is ResponseWithErrors {
    return isResponseError(error) && hasErrors(error.responseJSON);
}
